import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgRepairShop(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.904 5.09A1.5 1.5 0 019.347 4H54.827a1.5 1.5 0 011.447 1.104l4.664 17.046a1.488 1.488 0 01.062.463c-.019 4.246-3.7 7.495-8 7.495-2.655 0-5.075-1.24-6.542-3.188-1.576 1.968-4.18 3.188-6.957 3.188-2.804 0-5.43-1.242-7-3.241-1.572 2-4.197 3.241-7 3.241-2.804 0-5.43-1.242-7-3.241-1.572 2-4.197 3.241-7 3.241-4.462 0-8.474-3.146-8.5-7.484a1.493 1.493 0 01.063-.478l4.84-17.055zm50.092 17.676L53.683 7H10.48L6.006 22.77c.12 2.23 2.329 4.338 5.495 4.338 3.255 0 5.5-2.23 5.5-4.528a1.5 1.5 0 013 0c0 2.299 2.244 4.529 5.5 4.529 3.255 0 5.5-2.23 5.5-4.529a1.5 1.5 0 013 0c0 2.299 2.244 4.529 5.5 4.529 3.255 0 5.5-2.23 5.5-4.529a1.5 1.5 0 013 0c0 2.397 2.13 4.529 5 4.529 2.795 0 4.889-2.023 4.995-4.343z",
      fill: "#7373FF"
    }, void 0), _jsx("path", {
      d: "M10 29.613V55.75a3 3 0 003 3h8m33-29.137V55.75a3 3 0 01-3 3h-8",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.5 34.391a7.115 7.115 0 00-4.789 1.892c-1.474 1.372-2.461 3.478-2.461 6.391 0 .951.14 2.445.97 3.936.749 1.345 2.01 2.6 4.03 3.458v8.681a1.25 1.25 0 102.5 0v-9.544a1.25 1.25 0 00-.853-1.185c-1.973-.661-2.966-1.68-3.492-2.626-.545-.978-.655-1.996-.655-2.72 0-2.312.763-3.722 1.664-4.56a4.59 4.59 0 011.836-1.038v5.598c0 .403.195.781.522 1.016l3.468 2.488a1.245 1.245 0 001.204.177c.112-.043.22-.102.317-.177l3.468-2.488a1.25 1.25 0 00.521-1.016v-5.598a4.59 4.59 0 011.836 1.038c.901.838 1.665 2.249 1.665 4.56 0 .724-.11 1.742-.655 2.72-.527.946-1.52 1.965-3.493 2.626a1.25 1.25 0 00-.853 1.185v9.544a1.25 1.25 0 102.5 0v-8.681c2.02-.859 3.282-2.113 4.03-3.458.83-1.491.97-2.985.97-3.936 0-2.913-.987-5.019-2.46-6.39a7.115 7.115 0 00-4.79-1.893c-.69 0-1.25.56-1.25 1.25v6.392L32 43.647l-2.25-1.614V35.64c0-.69-.56-1.25-1.25-1.25z",
      fill: "#FF6652"
    }, void 0)]
  }), void 0);
}

export default SvgRepairShop;